<template>
  <div ref="mobileSearchVilla">
    <div
      v-show="showOnly"
      :class="[
        'mobile-search-villa',
        'searchVilla',
        'villa-search',
        {
          'mobile-search-villa--sticky': isSticky && !isFooterInView,
          'mobile-search-villa--space': region === 'homepage' && !isNav,
        },
      ]"
      :style="getLayering"
    >
      <button
        v-if="!isOpen"
        class="mobile-search-villa__toggle btn-primary-dark-lrg"
        type="button"
        @click="openSearch"
      >
        {{ textFindVillas }}
      </button>
    </div>

    <div
      v-if="isSticky && !isFooterInView"
      class="mobile-search-villa__sticky-placeholder"
    />

    <div
      v-if="isOpen"
      :class="[
        'villa-search',
        'mobile-search-villa__container',
        { 'mobile-search-villa__container--open': isOpen },
      ]"
    >
      <div class="mobile-search-villa__header">
        <h1 class="heading">Find a villa</h1>
        <button @click.prevent.stop="closeSearch">
          <Cross />
        </button>
      </div>
      <div v-if="isOpen" class="mobile-search-villa__inner">
        <h3 v-if="!isGreece" class="sub-heading">Location</h3>
        <MultipleDestinations v-if="!isGreece" :postion-top="'72px'" />

        <h3 class="sub-heading">Add Dates</h3>
        <TTTDatePickerInput
          :within-modal="true"
          :instance-name="instanceName"
          :no-border="true"
          @visible="handleDatePickerVisibilityChange"
        />

        <h3 class="sub-heading">Guests</h3>
        <GuestsDropdown />

        <h3 class="sub-heading">Bedrooms</h3>
        <BedroomsDropdown />
      </div>
      <button
        class="villa-search__submit btn-primary-dark-lrg"
        type="button"
        @click="search($event)"
      >
        {{ textFindVillas }}
      </button>
    </div>
  </div>
</template>

<script>
import { _ } from "vue-underscore";

import trackingHelper from "../../mixins/trackingHelper";
import closeTab from "../../mixins/closeTab";

import Bus from "../../events/bus";

import TTTDatePickerInput from "../TTTDatePicker/TTTDatePickerInput.vue";
import MultipleDestinations from "./MultipleDestinations.vue";
import GuestsDropdown from "./GuestsDropdown.vue";
import BedroomsDropdown from "./BedroomsDropdown.vue";
import Cross from '../../components/icons/Cross.vue';

export default {
  name: "MobileSearchVilla",

  components: {
    TTTDatePickerInput,
    MultipleDestinations,
    GuestsDropdown,
    BedroomsDropdown,
    Cross,
  },

  mixins: [trackingHelper, closeTab],

  props: {
    instanceName: {
      type: String,
      default: "home",
    },
    textFindVillas: {
      type: String,
      default: "Search villas",
    },
    section: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
    // This is for GTM click tracking
    trackingCategory: {
      type: String,
      default: "topnav",
    },
  },

  data() {
    return {
      isOpen: false,
      scrollTop: 0,
      isDatePickerVisible: false,
    };
  },

  computed: {
    isGreece() {
      return this.$store.getters["pages/currentPage"]
        ? this.$store.getters["pages/currentPage"].parentPageId == 1087
        : false;
    },

    getDestinations() {
      return this.$store.getters["results/getDestinations"];
    },

    getSubDestinations() {
      return this.$store.getters["results/getSubDestinations"];
    },

    REGION_IDS() {
      return this.$store.getters["results/getRegionIDs"];
    },

    isResultsPage() {
      return this.$store.getters["pages/currentPage"]
        ? this.$store.getters["pages/currentPage"].templateId == 5
        : false;
    },

    isNav() {
      return this.section === "nav";
    },

    isHomePage() {
      return this.$store.getters["pages/currentPage"]
        ? this.$store.getters["pages/currentPage"].templateId == 3
        : false;
    },

    isHomeRegion() {
      return this.region == "homepage";
    },

    isGreekIslandsRegion() {
      return this.region == "greekislands";
    },

    isExquisiteMobile() {
      return this.region === "exquisite" && this.showonlyMobile;
    },

    showonlyTablet() {
      return this.$mq === "tablet" && this.showonly === "tablet";
    },

    showonlyMobile() {
      return this.$mq === "mobile" && this.showonly === "mobile";
    },

    showOnlyTabletDesktop() {
      return (
        this.showonly === "tabletdesktop" &&
        (this.$mq === "tablet" || this.$mq === "desktop")
      );
    },

    showOnly() {
      if (!this.$store.state.common.datepickerOpen) {
        return (
          this.showOnlyTabletDesktop ||
          this.showonlyMobile ||
          this.showonlyTablet ||
          this.isExquisiteMobile ||
          this.isHomeRegion ||
          this.isGreekIslandsRegion ||
          this.isNav
        );
      }
    },

    sticky: {
      get() {
        return this.$store.getters["searchvilla/getSticky"];
      },
      set(val) {
        this.$store.commit("searchvilla/setSticky", val);
      },
    },

    isSticky() {
      return this.sticky === true;
    },

    isFooterInView() {
      return this.$store.getters["filterbar/getFooterInView"];
    },

    getLayering() {
      return {
        zIndex: this.pickerOpen ? "3000" : "101",
      };
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.calculateSticky();
    setTimeout(() => this.calculateSticky(), 5000);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
    this.closeSearch();
  },

  methods: {
    openSearch() {
      this.scrollTop = window.scrollY;
      this.isOpen = true;

      document.body.style.overflow = "auto";
      document.body.style.position = "fixed";
    },

    closeSearch() {
      this.isOpen = false;

      document.body.style.overflow = "";
      document.body.style.position = "";

      this.$nextTick(() => {
        window.scrollTo(0, this.scrollTop);
      });
    },

    handleDatePickerVisibilityChange(isVisible) {
      // hack to toggle z-index
      if (isVisible) {
        this.isDatePickerVisible = isVisible;
      } else {
        // delay to not be under content while animating out
        setTimeout(() => (this.isDatePickerVisible = isVisible), 300);
      }
    },

    search(event) {
      event.preventDefault();
      event.stopPropagation();

      const selectedPeople = this.$store.getters["results/getPeople"];
      const selectedRooms = this.$store.getters["results/getBedrooms"];
      const destinationsIDs = this.getDestinations.map((des) => des.id);
      const destinationsNames = this.getDestinations.map((des) => des.name);
      const subDestinationsIDs = this.getSubDestinations.map((des) => des.id);

      // Hack for paxos & Antipaxos
      if (
        destinationsIDs.length > 0 &&
        destinationsIDs[0] === this.REGION_IDS.PAXOS
      ) {
        destinationsIDs.push(this.REGION_IDS.ANTIPAXOS);
      }

      const redirectTo = {
        url: this.$store.getters["pages/getPageURLById"](16),
        params: {
          ...(destinationsIDs.length > 0 && {
            des: destinationsIDs.toString(),
          }),
          ...(subDestinationsIDs.length > 0 && {
            subdes: subDestinationsIDs.toString(),
          }),
          ...(this.dates &&
            this.dates.start && {
              from: moment(this.dates.start).format("DD MMM YYYY"),
            }),
          ...(this.dates &&
            this.dates.end && {
              to: moment(this.dates.end).format("DD MMM YYYY"),
            }),
          ...(selectedPeople != "" && { people: selectedPeople }),
          ...(selectedRooms != "" && { rooms: selectedRooms }),
        },
      };

      // track every search click (for GTM tracking) - see trackingHelper mixin
      this.trackSearchClick(this.trackingCategory, {
        ...redirectTo.params,
        destinations: destinationsIDs,
        desNames: destinationsNames,
        people: selectedPeople,
        rooms: selectedRooms,
      });

      // Store
      this.$store.commit("results/setThinkExquisite", this.te);
      this.$router.push({ path: redirectTo.url, query: redirectTo.params });
      this.isResultsPage
        ? Bus.$emit("filterProperties", "SEARCH VILLA BAR")
        : null;
      this.closeTab();
    },

    calculateSticky() {
      if (this.$refs.mobileSearchVilla && !this.isNav) {
        const elementTop =
          this.$refs.mobileSearchVilla.getBoundingClientRect().top;
        const actualBottom = elementTop + 70;
        if (actualBottom < 0) {
          if (!this.sticky) this.sticky = true;
        } else {
          if (this.sticky) this.sticky = false;
        }
      }
    },

    handleResize: _.throttle(function () {
      this.calculateSticky();
    }, 200),

    handleScroll: _.throttle(function () {
      this.calculateSticky();
    }, 200),
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/config.scss";

.mobile-search-villa {
  position: relative;
  width: 100%;
  height: 72px;
  margin: 0 auto 0 auto;
  display: flex;
  background-color: transparent;
  border-radius: 5px;
  justify-content: center;
  overflow: visible;

  @media (min-width: 775px) {
    display: none;
  }

  &--sticky {
    position: fixed;
    bottom: -72px;
    left: 0;
    right: 0;
    transition: transform 0.4s ease-in-out;
    transform: translateY(-72px);
  }

  &--space {
    margin: 0;
  }

  &__toggle {
    width: 100%;
  }

  &__sticky-placeholder {
    display: block;
    visibility: hidden;
    height: 72px;
    margin: 24px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $stoneCream;
    z-index: 1000;
    overflow: auto;

    &.open {
      transition: all 0.4s ease-in-out;
      margin-top: 0;
    }
  }

  &__header {
    padding: 20px;
    border-bottom: 1px solid $yellowStone;
    background: $stoneCream;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &__inner {
    padding: 0 20px 100px 20px;
    margin-bottom: 20px;
    overflow: hidden scroll;
    flex-grow: 1;
  }
}

.heading {
  font-size: 24px;
  margin: 0;
}

.sub-heading {
  margin: 20px 0;
}
</style>
